var styles = {"box":"ProfileModal_box_1pybx_1","subTitle":"ProfileModal_subTitle_1pybx_64","list":"ProfileModal_list_1pybx_75","divider":"ProfileModal_divider_1pybx_125","trigger":"ProfileModal_trigger_1pybx_131","count":"ProfileModal_count_1pybx_205"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
